import { render, staticRenderFns } from "./PackageEntry.vue?vue&type=template&id=2783f715&scoped=true&"
import script from "./PackageEntry.vue?vue&type=script&lang=js&"
export * from "./PackageEntry.vue?vue&type=script&lang=js&"
import style0 from "./PackageEntry.vue?vue&type=style&index=0&id=2783f715&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2783f715",
  null
  
)

export default component.exports